export const BinIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2.5L9 3.5H4V5.5H5V20.5C5 21.0222 5.19133 21.5546 5.56836 21.9316C5.94539 22.3087 6.47778 22.5 7 22.5H17C17.5222 22.5 18.0546 22.3087 18.4316 21.9316C18.8087 21.5546 19 21.0222 19 20.5V5.5H20V3.5H15L14 2.5H10ZM7 5.5H17V20.5H7V5.5ZM9 7.5V18.5H11V7.5H9ZM13 7.5V18.5H15V7.5H13Z"
        fill="#4C4B5B"
      />
    </svg>
  );
};
